import { createContext, useContext, useState, useEffect } from "react";
import { apiFetch } from "../../hooks/apiFetch";
import { useUser } from "./UserContext";
const UserPaymentContext = createContext();

export function UserPaymentProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [paidData, setPaidData] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [itemsLimit, setItemsLimit] = useState(5);
    const [currentPaymentStatus, setCurrentPaymentStatus] = useState(null);
    const { isLogIn } = useUser();

    useEffect(() => {
        if (!isLogIn) {
            setPaidData(null);
            setLoading(false);
            return;
        }
        async function fetchRequests() {
            try {
                const dataPaid = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/payment/my-payments?${searchQuery ? "" : `page=${currentPage}&limit=${itemsLimit}${currentPaymentStatus ? `&status=${currentPaymentStatus}` : ""}`}`);
                setPaidData(dataPaid)
            } catch (err) {
                setPaidData(null)
            }
            finally {
                setLoading(false);
            }
        }
        fetchRequests();
        // }
    }, [currentPage, currentPaymentStatus, searchQuery, itemsLimit, isLogIn]);

    return (
        <UserPaymentContext.Provider
            value={{
                paidData, loading, setPaidData,
                currentPage, setCurrentPage,
                searchQuery, setSearchQuery,
                itemsLimit, setItemsLimit,
                currentPaymentStatus, setCurrentPaymentStatus
            }}>
            {children}
        </UserPaymentContext.Provider>
    );
}

export function useUserPayment() {
    return useContext(UserPaymentContext);
}